/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { ECompanySize } from "../types/ECompanySize.ts";

/**
 * @description 1 = MEI | 2 = ME | 3 = EPP | 4 = LTDA | 5 = SA | 6 = NotApplicable |
 */
export const eCompanySizeSchema = z
  .union([
    z.literal(1),
    z.literal(2),
    z.literal(3),
    z.literal(4),
    z.literal(5),
    z.literal(6),
  ])
  .describe(
    "1 = MEI | 2 = ME | 3 = EPP | 4 = LTDA | 5 = SA | 6 = NotApplicable | ",
  ) as unknown as ToZod<ECompanySize>;
